import { h, render } from 'preact';
import select from './utils/select';

const PRIMARY_GUTEN_TAG = 'subject-2018-elections';
const RELATED_CONTENT_URL = `https://www.texastribune.org/api/v1/content/?content_type=story,audio,video,pointer&tag=${PRIMARY_GUTEN_TAG}&tag!=object-tribcast&fields=id,url,readable_pub_date,headline,short_summary,lead_art&limit=3&format=json`;

import(/* webpackChunkName: "analytics" */ '@data-visuals/analytics').then(
  analytics => analytics.init()
);

import(/* webpackChunkName: "ads" */ './utils/ad-loader').then(
  ({ default: AdLoader }) => {
    const ads = new AdLoader();
    ads.init();
  }
);

const ribbonContainer = document.getElementById('ribbon-container');

if (ribbonContainer) {
  import(/* webpackChunkName: "Ribbon" */ './components/Ribbon').then(
    ({ default: Ribbon }) => render(<Ribbon />, ribbonContainer)
  );
}

// save our shifter
const shiftWindow = () => scrollBy(0, -50);

// jumper element reference
const jumper = document.getElementById('nav-dropdown');

// add change listener
jumper.addEventListener('change', event => {
  // the element that changed (jumper)
  const el = event.target;

  // its current selected value
  const value = el.value;

  // find the element that matches (value has # in it, so use querySelector instead)
  const match = document.querySelector(value);

  // scroll the match into view
  match.scrollIntoView();

  // lil' nudge
  shiftWindow();
});



// WEBPACK FOOTER //
// ./main.js